export const test = () => {
  // const usr = user();
};

export const user = () => {
  return JSON.parse(sessionStorage.getItem('user'));
};

export const validacionPermit = permit => {
  const currentUser = user();

  var res = false;
  if (currentUser) {
    if (Array.isArray(permit)) {
      permit.forEach(lPermit => {
        currentUser.roles_user.forEach(uRol => {
          uRol.permissions.forEach(uPermit => {
            if (lPermit === uPermit.name) {
              res = true;
            }
          });
        });
      });
    } else {
      currentUser.roles_user.forEach(uRol => {
        uRol.permissions.forEach(uPermit => {
          if (permit === uPermit.name) {
            res = true;
          }
        });
      });
    }
    /*     currentUser.roles_user.map((aplication)=>{
          aplication.permissions.map((permision)=>{
            if(permision.name===permit){
              res=true
            }
          })
        }) */
  }
  return res;
};

export const validacionRol = (rol, forceUser = null) => {
  const currentUser = forceUser ? forceUser : user();
  var res = false;
  if (currentUser) {
    if (Array.isArray(rol)) {
      rol.forEach(lRol => {
        currentUser.roles_user.forEach(uRol => {
          if (lRol === uRol.name) {
            res = true;
          }
        });
      });
    } else {
      currentUser.roles_user.forEach(uRol => {
        if (rol === uRol.name) {
          res = true;
        }
      });
    }
  }
  return res;
};

export const validacionApps = (app, forceUser = null) => {
  const currentUser = forceUser ? forceUser : user();
  var res = false;
  if (currentUser) {
    if (Array.isArray(app)) {
      app.forEach(lApp => {
        currentUser.roles_user.forEach(uRol => {
          if (lApp === uRol.application.name) {
            res = true;
          }
        });
      });
    } else {
      currentUser.roles_user.forEach(uRol => {
        if (app === uRol.application.name) {
          res = true;
        }
      });
    }
  }
  return res;
};

export const hasAnalistApps = app => {
  const currentUser = user();
  let res = false;
  let aux = currentUser.organization.applications.find(e => e.name === app);

  if (aux) {
    res = true;
  }

  return res;
};
